import type { ADMIN_PERMISSION_ACCESS_LEVEL } from './adminPermission.type';
import type { GroupAdminGroupView, GroupAdminPermission } from './groupAdmin.type';

export type GroupListAdminAccessLevel = ADMIN_PERMISSION_ACCESS_LEVEL.EDIT | ADMIN_PERMISSION_ACCESS_LEVEL.VIEW_ONLY;

export type GroupListAdminListView = {
  id: string;
  name: string;
  accessLevel: GroupListAdminAccessLevel;
};

export type GroupListAdminListingView = {
  userId: string;
  ssoUserId?: string | null;
  email: string | null;
  firstName: string;
  lastName: string;
  phone?: string | null;
  dob?: string | null;
  groups: GroupAdminGroupView[];
  lists: GroupListAdminListView[];
};

export type GroupListAdminView = GroupListAdminListingView & {
  middleName?: string | null;
  profileImageUrl?: string | null;
};

export type GroupListAdminGroupPayloadItem = {
  id: string;
  permissions: GroupAdminPermission[];
};

export type GroupListAdminListPayloadItem = {
  id: string;
  accessLevel: GroupListAdminAccessLevel;
};

export type UpsertGroupListAdminPayload = {
  firstName: string;
  lastName: string;
  email: string;
  middleName?: string | null;
  phone?: string | null;
  dob?: string | null;
  groups: GroupListAdminGroupPayloadItem[];
  lists: GroupListAdminListPayloadItem[];
};

export type CommunityListLookupItem = {
  id: string;
  name: string;
};

export enum GROUP_LIST_ADMIN_BULK_DELETE_ACTION {
  GROUP_ACCESS = 'group-access',
  LIST_ACCESS = 'list-access',
}
